import * as API from 'generated/api';

export function displayName(chat: API.FFPublicChat): string {
  if (chat.name == null) {
    // TODO: This currently happens for profile scrolls. We don't have access
    // to the creator's name, so we can't say "{user}'s scroll".
    return "";
  }

  if (chat.name.length !== 0) {
    return chat.name;
  }
  return "Unnamed chat"; // TODO
}
